import { useEffect, useState } from 'react';
import api from '../api';

// Debounced Photon autocomplete via the backend; aborts stale requests.
export function useAddressSearch(query, bias, enabled = true) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const biasLat = bias?.lat;
  const biasLng = bias?.lng;

  useEffect(() => {
    if (!enabled || query.trim().length < 3) {
      setSuggestions([]);
      return undefined;
    }
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const params = { q: query.trim() };
        if (biasLat != null && biasLng != null) {
          params.lat = biasLat;
          params.lng = biasLng;
        }
        const { data } = await api.get('/api/geo/autocomplete', { params, signal: controller.signal });
        setSuggestions(data || []);
      } catch (err) {
        if (err?.name !== 'CanceledError') setSuggestions([]);
      } finally {
        setLoading(false);
      }
    }, 350);
    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [query, biasLat, biasLng, enabled]);

  return { suggestions, loading };
}
